export default __webpack_public_path__ + "static/media/logo.min.323b07f2.png";